import { type IRole } from '../utils/translateUserRoleInRole';

export enum Roles {
  ADMIN = 'ROLE_ADMIN',
  BROKER_CONSULTANT = 'ROLE_BROKER_CONSULTANT',
  RENEWAL_COORDINATOR = 'ROLE_RENEWAL_COORDINATOR',
  RENEWAL_ANALYST = 'ROLE_RENEWAL_ANALYST',
  ACCOUNT_CLIENT_MANAGER = 'ROLE_ACCOUNT_CLIENT_MANAGER',
  ACCOUNT_SUPPORT = 'ROLE_ACCOUNT_SUPPORT',
  CLIENT = 'ROLE_CLIENT',
  EMPLOYEE = 'ROLE_EMPLOYEE',
  ONLINE_ACCOUNT_COORDINATOR = 'ROLE_ONLINE_ACCOUNT_COORDINATOR',
  IMPLEMENTER = 'ROLE_IMPLEMENTER',
  ONLINE_ACCOUNT_MANAGER = 'ROLE_ONLINE_ACCOUNT_MANAGER',
  EDI_ANALYST = 'ROLE_EDI_ANALYST',
  WELLNESS = 'ROLE_WELLNESS',
}

export const rolesWithLevel: IRole[] = [
  { key: Roles.ADMIN, value: 'Admin', level: 5 },
  {
    key: Roles.ONLINE_ACCOUNT_COORDINATOR,
    value: 'Online Account Coordinator',
    level: 4,
  },
  { key: Roles.IMPLEMENTER, value: 'Implementer', level: 4 },
  {
    key: Roles.ONLINE_ACCOUNT_MANAGER,
    value: 'Online Account Manager',
    level: 4,
  },
  { key: Roles.EDI_ANALYST, value: 'EDI Analyst', level: 4 },
  { key: Roles.BROKER_CONSULTANT, value: 'Broker/Consultant', level: 4 },
  { key: Roles.RENEWAL_COORDINATOR, value: 'Renewal Coordinator', level: 4 },
  { key: Roles.RENEWAL_ANALYST, value: 'Renewal Analyst', level: 4 },
  {
    key: Roles.ACCOUNT_CLIENT_MANAGER,
    value: 'Account/Client Manager',
    level: 4,
  },
  { key: Roles.ACCOUNT_SUPPORT, value: 'Account Support', level: 4 },
  { key: Roles.CLIENT, value: 'Client', level: 3 },
  { key: Roles.EMPLOYEE, value: 'Employee', level: 1 },
  { key: Roles.WELLNESS, value: 'Wellness', level: 4 },
];

export const clientAndEmployeeWithLevel = rolesWithLevel.filter((role) =>
  [Roles.CLIENT, Roles.EMPLOYEE].includes(role.key)
);

export const rolesWithoutAdminWithLevel = rolesWithLevel.filter(
  (role) => role.key !== Roles.ADMIN
);

export const AdminRoles = [Roles.ADMIN];

export const ManagerRoles = [
  Roles.BROKER_CONSULTANT,
  Roles.RENEWAL_COORDINATOR,
  Roles.RENEWAL_ANALYST,
  Roles.ACCOUNT_CLIENT_MANAGER,
  Roles.ACCOUNT_SUPPORT,
  Roles.ONLINE_ACCOUNT_COORDINATOR,
  Roles.IMPLEMENTER,
  Roles.ONLINE_ACCOUNT_MANAGER,
  Roles.EDI_ANALYST,
  Roles.WELLNESS,
];

export const AgenciesEligibleRoles = [
  Roles.BROKER_CONSULTANT,
  Roles.RENEWAL_COORDINATOR,
  Roles.RENEWAL_ANALYST,
  Roles.ACCOUNT_CLIENT_MANAGER,
  Roles.ACCOUNT_SUPPORT,
  Roles.ONLINE_ACCOUNT_COORDINATOR,
  Roles.IMPLEMENTER,
  Roles.ONLINE_ACCOUNT_MANAGER,
  Roles.EDI_ANALYST,
  Roles.WELLNESS,
];

export const EmployeeRoles = [Roles.EMPLOYEE];

export const ClientRoles = [Roles.CLIENT];

export const NotEmployeeRoles = [Roles.ADMIN, ...ManagerRoles, Roles.CLIENT];

/**
 * @deprecated
 * please use the `NotEmployeeRoles` instead.
 */
export const NotViewerUsers = [Roles.ADMIN, ...ManagerRoles, Roles.CLIENT];

export const HighUserRoles = [Roles.ADMIN, ...ManagerRoles];

export const ContactCardsRoles = [
  Roles.BROKER_CONSULTANT,
  Roles.ACCOUNT_CLIENT_MANAGER,
];
